import type React from 'react'

import css from './styles.module.css'

interface Props {
  value: string
  onChange: (value: string) => void
  readonly: boolean
}

export const TitleInput: React.FC<Props> = ({ value, onChange, readonly }) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) =>
    onChange(e.target.value)

  return (
    <div className={css.title_container}>
      <input
        disabled={readonly}
        className={css.input}
        value={value}
        onChange={handleChange}
      />
    </div>
  )
}
